(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[186],{

/***/ 8010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection",
      function () {
        return __webpack_require__(9411);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6746);





function NftImage(param) {
    var nft = param.nft, spinnerDimensionClasses = param.spinnerDimensionClasses;
    var ref, ref1;
    var imageId = null;
    if (nft === null || nft === void 0 ? void 0 : (ref = nft.params) === null || ref === void 0 ? void 0 : ref.url) {
        var ref2;
        imageId = nft === null || nft === void 0 ? void 0 : (ref2 = nft.params) === null || ref2 === void 0 ? void 0 : ref2.url.split("ipfs://")[1];
    }
    var imageUrl = "https://ipfs.io/ipfs/".concat(imageId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex items-center justify-center w-full bg-gray-800 aspect-square",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_2__.LazyLoadImage, {
                height: 400,
                width: 400,
                src: imageUrl,
                alt: nft === null || nft === void 0 ? void 0 : (ref1 = nft.params) === null || ref1 === void 0 ? void 0 : ref1.name,
                effect: "blur",
                wrapperClassName: "absolute inset-0 !w-full !h-full z-10"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                dimensionClasses: spinnerDimensionClasses
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NftImage);


/***/ }),

/***/ 7031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2369);



function PageHeader(param) {
    var heading = param.heading, description = param.description, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-2xl mx-auto mt-5 mb-10",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "space-y-4 text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "text-3xl font-extrabold tracking-tight text-neutral-200 sm:text-5xl md:text-6xl",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "block xl:inline",
                            children: heading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-base text-neutral-500 md:text-xl",
                                children: description
                            }),
                            children
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 6746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function Spinner(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 4 : _strokeWidth, _dimensionClasses = param.dimensionClasses, dimensionClasses = _dimensionClasses === void 0 ? "w-16 h-16" : _dimensionClasses;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: "".concat(dimensionClasses, " text-white animate-spin"),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: strokeWidth
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 9411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ collection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/NftImage.js
var NftImage = __webpack_require__(6770);
;// CONCATENATED MODULE: ./components/NftPreview.js



function NftPreview(param) {
    var nft = param.nft;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-4 overflow-hidden bg-gray-800 rounded-md aspect-square",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://www.nftexplorer.app/asset/".concat(nft.index || nft.id),
                    target: "_blank",
                    rel: "noreferrer",
                    className: "absolute inset-0 w-full h-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NftImage/* default */.Z, {
                        nft: nft,
                        spinnerDimensionClasses: "w-12 h-12"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center space-y-1 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-sm",
                    children: nft === null || nft === void 0 ? void 0 : (ref = nft.params) === null || ref === void 0 ? void 0 : ref.name
                })
            })
        ]
    });
}
/* harmony default export */ var components_NftPreview = (NftPreview);

;// CONCATENATED MODULE: ./components/CollectionGrid.js



function CollectionGrid(param) {
    var assets = param.assets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-x-5 gap-y-8",
        children: assets.map(function(asset, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NftPreview, {
                    nft: asset
                })
            }, index);
        })
    });
}
/* harmony default export */ var components_CollectionGrid = (CollectionGrid);

// EXTERNAL MODULE: ./components/PageHeader.js
var PageHeader = __webpack_require__(7031);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(1838);
// EXTERNAL MODULE: ./components/Container.js
var Container = __webpack_require__(2369);
;// CONCATENATED MODULE: ./pages/collection.js







function Collection(param) {
    var assets = param.assets;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "V1 Collection - ".concat(config/* default.siteName */.Z.siteName)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                heading: "AlgoDaruma - V1",
                description: "What do you get when you combine the love Algorand technology and the love of Japanese culture? You get ALGODARUMA!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CollectionGrid, {
                    assets: assets
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var collection = (Collection);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [143,774,888,179], function() { return __webpack_exec__(8010); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);